// DeleteChannel.js

import React from "react";
import { useChatContext } from "stream-chat-react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const DeleteChannel = ({ setIsEditing }) => {
  const { channel } = useChatContext();

  const deleteChannel = async () => {
    try {
      await channel.delete();
      setIsEditing(false); // Close the edit channel view after deletion
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  return (
    <div style={{ marginRight: "5px" }}>
      <Stack direction="row" spacing={2}>
        <Button
          onClick={deleteChannel}
          variant="contained"
          color="error"
          size="small"
        >
          Delete Channel
        </Button>
      </Stack>
      {/* <p>Delete Channel</p> */}
      {/* <button onClick={deleteChannel}>DELETE CHANNEL</button> */}
    </div>
  );
};

export default DeleteChannel;
